import { Form } from "react-bootstrap"

export const Switch = ({ label, onSwitchChange,val, disabled = false, defaultValue }) => {
    return <Form.Check
    disabled={disabled}
        type="switch"
        label={label}
        checked={val}
        defaultValue={defaultValue}
        onChange={(event) => onSwitchChange(event.target.checked)}
    />
}